import {NgModule} from "@angular/core";
import {RouterModule} from "@angular/router";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ModalModule, TabsModule} from 'ng2-bootstrap';
import {TimepickerModule} from 'ng2-bootstrap/timepicker';
import {DatepickerModule} from 'ng2-bootstrap/datepicker';
import {FileUploadModule} from 'ng2-file-upload';
import {FullCalendarModule} from "../../modules/fullcalendar/fullcalendar.module";
import {CheckboxModule} from 'primeng/primeng';

import {PipesModule} from "../../pipes/pipes.module";
import { ControlMessagesModule } from "../../components/validation/control-messages.module";
import {DataTableModule} from './../../components/common/datatables/datatable.module';
import {LeadsComponent} from "./leads.component";
import {OverdueScheduleDirective} from "./leads.directives";
import {LeadListComponent} from './list/lead-list.component';
import {LeadScheduleListComponent} from './schedule-list/lead-schedule-list.component';
import {LeadCreateClientComponent} from './create-client/lead-create-client.component';
import {LeadStatisticsComponent} from './statistics/lead-statistics.component';
import {LeadSetStatusComponent} from './set-status/lead-set-status.component';
import {LeadImportComponent} from './import/lead-import.component';
import {LeadImportQuickComponent} from './import/quick.component';
import {LeadAssignOpenerComponent} from "./assign-opener/lead-assign-opener.component";
import {LeadGlobalSearchComponent} from "./global-search/global-search.component";
import {ImportListComponent} from "./import-list/component";
import {LeadEditComponent} from "./edit/lead-edit.component";
import {ScheduledCallbacksModule} from "../../modules/scheduled-callbacks/scheduled-callbacks.module";
import {ClientsService} from "../../models/clients/clients.service";
import {ClientVolumesService} from "../../models/client-volumes/client-volumes.service";
import {ClientContactsService} from "../../models/client-contacts/client-contacts.service";
import {ClientBanksService} from "../../models/client-banks/client-banks.service";
import {ClientOwnersService} from "../../models/client-owners/client-owners.service";
import {ClientProcessorsService} from "../../models/client-processors/client-processors.service";
import {PricingsService} from "../../models/pricings/pricings.service";
import {CommunicationService} from "../../models/communication/communication.service";
import {PermissionsService} from "../../services/permissions/permissions.service";
import {Ng2GoogleChartsModule} from "ng2-google-charts";
import {LeadsService} from "../../models/leads/leads.service";
import {LeadImportsService} from "../../models/leads/leadImports.service";
import {UsersService} from "../../models/users/users.service";
import {ProvincesService} from "../../models/provinces/provinces.service";
import {ConfirmModule} from '../../modules/confirm/confirm.module';

import {BadgesHelper} from "../../services/BadgesHelper";
import {BadgesService} from "../../models/badges/badges.service";
import {ClientNotesModule} from "../../modules/client-notes/client-notes.module";

import { MentionModule } from 'angular2-mentions/mention';


@NgModule({
    declarations: [
        LeadsComponent,
        LeadListComponent,
        LeadScheduleListComponent,
        LeadCreateClientComponent,
        LeadStatisticsComponent,
        LeadSetStatusComponent,
        LeadImportComponent,
        LeadImportQuickComponent,
        LeadEditComponent,
        LeadAssignOpenerComponent,
        LeadGlobalSearchComponent,
        ImportListComponent,
        OverdueScheduleDirective
    ],
    imports: [
        TimepickerModule.forRoot(),
        DatepickerModule.forRoot(),
        CheckboxModule,
        CommonModule,
        RouterModule,
        FileUploadModule,
        FormsModule,
        ControlMessagesModule,
        ReactiveFormsModule,
        DataTableModule,
        ModalModule,
        PipesModule,
        ScheduledCallbacksModule,
        TabsModule,
        Ng2GoogleChartsModule,
        FullCalendarModule,
        ConfirmModule,
        ClientNotesModule,
        MentionModule
    ],
    exports: [
        OverdueScheduleDirective,
        LeadImportQuickComponent
    ],
    providers: [
        ClientsService,
        LeadsService,
        LeadImportsService,
        ClientVolumesService,
        ClientContactsService,
        ClientBanksService,
        ClientOwnersService,
        ClientProcessorsService,
        PricingsService,
        PermissionsService,
        CommunicationService,
        UsersService,
        ProvincesService,
        BadgesService,
        BadgesHelper
    ]
})

export class LeadModule {
}


// WEBPACK FOOTER //
// ./src/app/views/leads/leads.module.ts